// extracted by mini-css-extract-plugin
module.exports = {"modal":"DistSvg_modal__Uy2yS","modal__title":"DistSvg_modal__title__2_bWi","modal__text":"DistSvg_modal__text__H_s3k","button":"DistSvg_button__riEek"};